import React, { useContext } from 'react';

import { I18nContext } from '../contexts/I18nProvider';
import useWindowWidth from '../hooks/useWindowWidth';

import Header from './Header/Header';
import HeaderMobile from './Header/HeaderMobile';
import SubHeader from './Subheader/SubHeader';
import NotificationsPanel from '../components/NotificationsPanel';
import Whatsapp from '../components/whatsapp/Whatsapp';
import Popup from '../components/Popup';
import Footer from './Footer/Footer';

const Layout = ({ children }) => {
  // const auth = useContext(AuthContext);
  // const { isAuthenticated } = auth;

  const width = useWindowWidth();
  // const { validating, user } = useContext(AuthContext);
  const { language } = useContext(I18nContext);

  // if (validating.isValidating || !user) {
  // 	return <Loader message={'Autenticando'} />;
  // }

  return (
    <>
      {width > 992 ? (
        <>
          <Header language={language} />
          <SubHeader language={language} />
        </>
      ) : (
        <HeaderMobile language={language} />
      )}
      <NotificationsPanel language={language} />
      {children}
      <Whatsapp />
      <Popup />
      <Footer language={language} />
    </>
  );
};

export default Layout;
